import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface UsageData {
  tier: 'free' | 'pro' | 'enterprise';
  evaluations_used: number;
  transcriptions_used: number;
  repairs_used: number;
  monthly_evaluation_limit: number;
  monthly_transcription_limit: number;
  monthly_repair_limit: number;
  overage_evaluations: number;
  overage_transcriptions: number;
  overage_repairs: number;
  period_start: string;
  period_end: string;
}

export function useUsage() {
  return useQuery({
    queryKey: ['usage'],
    queryFn: async (): Promise<UsageData | null> => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return null;

      const { data } = await supabase
        .from('usage_credits')
        .select('*')
        .eq('user_id', session.user.id)
        .single();

      return data as unknown as UsageData | null;
    },
    refetchInterval: 30_000, // refresh every 30s
  });
}
